import createRestApiClient from "../../utility/createRestApiClient";

import {
  FETCH_ORG_PREFERENCES_SUCCESS,
  FETCH_ORG_PREFERENCES_LOADING,
  FETCH_ORG_PREFERENCES_FAILED
} from "../actionTypeConstants/orgPreferences";

import { getCookieData } from "../../utility/cookieHandler/handler";
import {
  getUrlByUserDomain,
  safeParseJwt
} from "../../utility/utilityFunctions";

const mockApiEndpoint = getUrlByUserDomain(
  process.env.REACT_APP_ORG_PREFERENCES_HOST_PREFIX ||
    window?._env_?.REACT_APP_ORG_PREFERENCES_HOST_PREFIX
);

const mockApiClient = createRestApiClient().withConfig({
  baseURL: mockApiEndpoint
}).client;

export function fetchOrgPreferences() {
  let cookieName = process.env.REACT_APP_COOKIE_NAME;
  let access_token = getCookieData(cookieName);
  if (!access_token) {
    window.location.href =
      process.env.REACT_APP_LOGIN_URL || window?._env_?.REACT_APP_LOGIN_URL;
  }
  const { organization_id } = safeParseJwt(access_token);
  if (!organization_id) {
    return;
  }
  const header = {
    Authorization: `Bearer ${access_token}`,
    Accept: "application/json"
  };

  return {
    types: [
      FETCH_ORG_PREFERENCES_LOADING,
      FETCH_ORG_PREFERENCES_SUCCESS,
      FETCH_ORG_PREFERENCES_FAILED
    ],
    promise: () =>
      mockApiClient.get(`/api/org_preferences/${organization_id}`, {
        headers: header
      })
  };
}
